import * as types from './mutation-types'
import * as userTypes from '../user/mutation-types'
import * as rootTypes from '../../mutation-types'
import router from '@/router.js'
import tr from '../../../plugins/i18n'

export const login = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.get('/sanctum/csrf-cookie').then((response) => {
      window.axios
        .post('/login', data)
        .then((response) => {
          commit(types.SET_LOGOUT, false)
          commit('user/' + userTypes.RESET_CURRENT_USER, null, { root: true })
          commit(rootTypes.UPDATE_APP_LOADING_STATUS, false, { root: true })

          window.toastr['success'](tr.t('general.login_success'))
          resolve(response)
        })
        .catch((err) => {
          commit(types.AUTH_ERROR, err.response)
          reject(err)
        })
    })
  })
}

export const forgotPassword = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post('/api/v1/auth/password/email', data)
      .then((response) => {
    
      resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
    
  })
}

export const setLogoutFalse = ({ state, commit }) => {
  commit(types.SET_LOGOUT, false)
}

export const setSubscribedFalse = ({ state, commit }) => {
  commit(types.SET_SUBSCRIBED, false)
}

export const isSubscribed = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get('/api/v1/is_subscribed', data)
      .then((response) => {
       
        commit(types.SET_SUBSCRIBED, response.data.subscribed)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}


export const logout = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    if (state.isLoggedOut) {
      resolve()
      return true
    }
    commit(types.SET_LOGOUT, true)

    window.axios
      .get('/auth/logout')
      .then(() => {
       router.push('/login')
        window.toastr['success'](tr.t('general.log_out_success'))
      })
      .catch((err) => {
        router.push('/login')
        reject(err)
      })
  })
}

export const resendEmailVerification = ({state, commit}) => {
  return new Promise((resolve, reject) => {
    window.axios
    .post('/email/verification-notification')
    .then((response)=> {
      console.log(response)
      resolve(response)
    })
    .catch((error) => {
      console.log(error)
      reject(error)
    })
  })
}